import { EventApi } from "@fullcalendar/react";
import { IEventData, UtilityDate } from "../../utils";
import { SvgPipe } from "../../assets/svg";

interface IProps {
  event: EventApi;
  metaData: IEventData;
}

export function ListViewEvent({ event, metaData }: IProps) {
  return (
    <div className="text-start p-1 text-dark d-flex align-center">
      <p className="text-wrap">
        {UtilityDate.formatTime(event.start!) +
          " - " +
          UtilityDate.formatTime(event.end!)}
      </p>
      <div className="px-2">
        <SvgPipe />
      </div>
      <div className="text-small">
        <div className="d-flex">
          <p className="m-0">
            Caregiver:
            <span className="fw-semi-bold"> {metaData.caregiverName}</span>
          </p>
          <div className="px-2">
            <SvgPipe />
          </div>
          <p className="m-0">
            Patient:
            <span className="fw-semi-bold"> {metaData.patientName}</span>
          </p>
        </div>
      </div>
    </div>
  );
}

export function MonthlyViewEvent({ event, metaData }: IProps) {
  return (
    <div className="text-start p-1 text-dark">
      <small className="text-wrap">
        {UtilityDate.formatTime(event.start!) +
          " - " +
          UtilityDate.formatTime(event.end!)}
      </small>
      <div className="text-smallest">
        <p className="m-0">
          <span className="color-green">●</span> Caregiver:
          <span className="fw-semi-bold"> {metaData.caregiverName}</span>
        </p>
        <p className="m-0">
          <span className="color-red">●</span> Patient:
          <span className="fw-semi-bold"> {metaData.patientName}</span>
        </p>
      </div>
    </div>
  );
}
